import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { TecnicoResponse } from "../../../shared/response/proyectos/TecnicoResponse";
import { TecnicoPayload } from "../../../shared/services/api/payload/proyectos/TecnicoPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { TecnicoService, toTecnicoResponse } from "./TecnicoService";

/** Alta y edición de técnicos; el resultado reemplaza la fila del listado. */
export class TecnicoSaveService extends ServiceSaveBase<TecnicoResponse, TecnicoPayload> {
  protected readonly cache = TecnicoService.instance;

  /**
   * gRPC-Web (`GuardarTecnico`): el alta crea su usuario de Plataforma y le envía la invitación. Inactivar
   * el técnico inactiva ese usuario y cierra sus sesiones. En Nitrofert, si ya hay un usuario con ese correo, la
   * ficha se enlaza a él (`enlazadoAUsuarioExistente`) y editar la ficha no toca al usuario.
   */
  protected async sendSave(p: TecnicoPayload): Promise<TecnicoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarTecnico({
      id: p.id ?? undefined,
      nombre: p.nombre,
      email: p.email,
      telefono: p.telefono || undefined,
      zona: p.zona,
      isActivo: p.isActivo,
    }));
    return toTecnicoResponse(r);
  }
}
